export const STATUS_COLORS = {
  ok: { hex: "#039860", label: "Aucune anomalie", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  minor: { hex: "#FE8817", label: "Mineure", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  major: { hex: "#B91C25", label: "Majeure", cls: "bg-red-50 text-red-700 border-red-200" },
  critical: { hex: "#082553", label: "Critique", cls: "bg-slate-900 text-white border-slate-900" },
  inactive: { hex: "#A2A1A2", label: "Inactif", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const CLEANING_RING = {
  ASP: { hex: "#0075FD", ringCls: "apt-ring-asp", badge: "bg-blue-50 text-blue-700 border-blue-200" },
  Lux: { hex: "#00914F", ringCls: "apt-ring-lux", badge: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  "White and Clean": { hex: "#A828FB", ringCls: "apt-ring-wc", badge: "bg-violet-50 text-violet-700 border-violet-200" },
  Alexandra: { hex: "#00CEE2", ringCls: "apt-ring-alex", badge: "bg-teal-50 text-teal-700 border-teal-200" },
  "Non renseigné": { hex: "#9B9B9D", ringCls: "", badge: "bg-slate-50 text-slate-500 border-slate-200" },
};

export const SEVERITY = {
  mineur: { label: "Mineure", cls: "bg-orange-50 text-orange-700 border-orange-200", hex: "#F97316" },
  majeur: { label: "Majeure", cls: "bg-red-50 text-red-700 border-red-200", hex: "#EF4444" },
  critique: { label: "Critique", cls: "bg-slate-900 text-white border-slate-900", hex: "#0F172A" },
};

export const PROBLEM_STATUSES = ["À traiter", "Résolu"];
export const CATEGORIES = [
  "Plomberie", "Électricité", "Serrurerie", "Chauffage", "Climatisation", "Wi-Fi",
  "Électroménager", "Mobilier", "Literie", "Propreté", "Nuisibles",
  "Fenêtre / porte", "Autre",
];
export const PIECES = [
  "Chambre 1", "Chambre 2", "Chambre 3", "Salon", "Entrée", "Couloir",
  "Cuisine", "Salle de bain", "WC", "Terrasse", "Balcon", "Appartement entier", "Autre",
];
export const REFERENTS = ["Dylan", "Andrea"];
export const CLEANING_COMPANIES = ["ASP", "Lux", "White and Clean", "Alexandra", "Non renseigné"];
export const APT_STATUSES = ["Onboarding", "En ligne", "Inactif"];

export const APT_STATUS_META = {
  "Onboarding": { cls: "bg-sky-50 text-sky-700 border-sky-200", dot: "#0EA5E9" },
  "En ligne": { cls: "bg-slate-100 text-slate-700 border-slate-200", dot: "#334155" },
  "Inactif": { cls: "bg-slate-100 text-slate-500 border-slate-200", dot: "#94A3B8" },
};

export const USER_STATUS_META = {
  actif: { label: "Actif", dot: "#22C55E", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  en_attente: { label: "En attente", dot: "#F59E0B", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  suspendu: { label: "Suspendu", dot: "#F59E0B", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  inactif: { label: "Inactif", dot: "#94A3B8", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const ROLE_LEVELS = [
  { value: "admin", level: 1, label: "Manager" },
  { value: "account_manager", level: 2, label: "Account Manager" },
  { value: "assistant_manager", level: 3, label: "Assistant Account Manager" },
  { value: "cleaning", level: 4, label: "Ménage" },
  { value: "read_only", level: 5, label: "Lecture seule" },
];
export const ROLE_LABELS = Object.fromEntries(
  ROLE_LEVELS.map((r) => [r.value, `Niveau ${r.level} — ${r.label}`])
);
export const BM_ROLES = ["admin", "account_manager", "assistant_manager"];
export const ADMIN_ROLES = ["admin", "account_manager"];
export const ALL_ROLES = [...BM_ROLES, "cleaning", "read_only"];

export const CHECKOUT_METHODS = ["Boîte à clés", "KeyNest", "Réception", "Sur place (clé sur la table)"];

export const TENANT_LANGUAGES = [
  ["fr", "Français"], ["en", "Anglais"], ["es", "Espagnol"], ["pt", "Portugais"],
  ["de", "Allemand"], ["nl", "Néerlandais"], ["it", "Italien"], ["ru", "Russe"],
  ["hi", "Hindi"], ["ar", "Arabe"], ["zh", "Chinois"], ["ko", "Coréen"],
  ["ja", "Japonais"], ["sv", "Suédois"], ["no", "Norvégien"],
];

export const CLEANING_STATUS = {
  pas_fait: { label: "Pas fait", cls: "bg-red-50 text-red-700 border-red-200" },
  en_cours: { label: "En cours", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  termine: { label: "Terminé", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const KEY_HANDOVER = ["KeyNest", "Boîte à clés", "Check-in physique"];

export const PLATFORM_META = {
  airbnb: { name: "Airbnb", color: "#FF5A5F" },
  booking: { name: "Booking.com", color: "#003580" },
  vrbo: { name: "Vrbo / Abritel", color: "#0E2F56" },
  expedia: { name: "Expedia", color: "#FFC94A" },
};
